module.exports = __webpack_public_path__ + "img/bg5.ae158365.jpg";